import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

export interface RespUploadFile {
  success: boolean;
  data: UploadedFile;
  error: string | null;
}

export interface UploadedFile {
  destination: string;
  fileName: string;
  message: string;
}

@Injectable({
  providedIn: 'root',
})

export class ArchivosService {
  private filesApiUrl = environment.baseURL + 'files';

  private readonly httpClient = inject(HttpClient);

  uploadFile(file: File, destination: string): Observable<RespUploadFile> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('destination', destination);
    return this.httpClient.post<RespUploadFile>(this.filesApiUrl + `/upload`, formData);
  }

  deleteFile(url: string): Observable<RespUploadFile> {
    return this.httpClient.delete<RespUploadFile>(this.filesApiUrl + `/delete`, {
      params: { url },
    });
  }

  downloadFile(url: string): Observable<Blob> {
    return this.httpClient.get(`${this.filesApiUrl}/download-file?url=${url}`, { responseType: 'blob' });
  }
}
